// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2xEL1","notes":"Notes_notes__3V5Hv","note":"Notes_note__qvOVE","markdown":"Notes_markdown__2IBdh"};